<template>
  <div class="gwd-table">
    <div class="gwd-table-header narrow-cost-list">
      <span>Tüüp</span>
      <span>Kirjeldus</span>
      <span>Kuupäev</span>
      <span>Kogus</span>
      <span>Kulu/Tulu summa</span>
      <span class="flex justify-end">
        <button class="btn-primary" @click="toggleShowAdded">
          {{ showAdded ? "Peida" : "Näita" }}
        </button>
      </span>
    </div>
    <template-cost
      v-for="templateType in [
        {
          id: 'resourceCosts',
          costs: filteredCosts.filter((x) => x.type === 'resourceCost'),
          type: 3,
          name: 'Ressurss',
        },
        {
          id: 'supplierCosts',
          costs: filteredCosts.filter((x) => x.type === 'supplierCost'),
          type: 5,
          name: 'Hankija',
        },
        {
          id: 'extraCosts',
          costs: filteredCosts.filter((x) => x.type === 'extraCost'),
          type: 6,
          name: 'Lisatöö',
        },
        {
          id: 'equipmentCosts',
          costs: filteredCosts.filter((x) => x.type === 'equipmentCost'),
          type: 4,
          name: 'Tehnika',
        },
      ]"
      :key="templateType.id"
      :id="templateType.id"
      :template="templates.find((x) => x.type === templateType.type)"
      :costs="templateType.costs"
      :name-prefix="templateType.name"
      :added-cost-ids="addedCostIds"
      :show-added="showAdded"
      :task="null"
      :combine-costs-active="combineCostsActive"
      :combined-costs="combinedCosts"
      :status="status"
      @addItem="addItem"
      @selectTemplate="selectTemplate"
      @addToCombinedCosts="addToCombinedCosts"
      :type="templateType.type"
      class="flex"
    />
  </div>
</template>

<script>
import TemplateCost from "@/components/invoices/TemplateCost.vue";
import moment from "moment/moment";

export default {
  name: "NoTaskCosts",
  components: { TemplateCost },
  props: {
    noTaskCosts: {
      type: Object,
      default: () => {},
    },
    templates: {
      type: Array,
      default: () => [],
    },
    addedCostIds: {
      type: Array,
      default: () => [],
    },
    combinedCosts: {
      type: Array,
      default: () => [],
    },
    combineCostsActive: {
      type: Boolean,
      default: true,
    },
    showAdded: {
      type: Boolean,
      default: false,
    },
    status: {
      type: Number,
      default: null,
    },
    timeFilter: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      filteredCosts: [],
    };
  },
  mounted() {
    this.filterCosts();
  },
  methods: {
    filterCosts() {
      if (this.timeFilter && this.timeFilter.filter) {
        this.filteredCosts = this.noTaskCosts.costs.filter((x) => {
          return moment(x.occurrence_time).isBetween(
            this.timeFilter.startDate,
            this.timeFilter.endDate,
            "day",
            "[]"
          );
        });
      } else {
        this.filteredCosts = this.noTaskCosts.costs;
      }
    },
    combineAll() {
      const combined = this.combinedCosts.map((x) => `${x.type}${x.id}`);

      this.noTaskCosts.costs
        .filter((x) => !combined.includes(`${x.type}${x.id}`))
        .forEach((e) => {
          this.addToCombinedCosts(e);
        });
    },
    toggleShowAdded() {
      this.$emit("toggleShowAdded");
    },
    addItem(e) {
      this.$emit("addItem", e);
    },
    selectTemplate(template, task) {
      this.$emit("selectTemplate", template, task);
    },
    addToCombinedCosts(e) {
      this.$emit("addToCombinedCosts", e);
    },
  },

  watch: {
    timeFilter: {
      deep: true,
      handler() {
        this.filterCosts();
      },
    },
  },
};
</script>
<style scoped lang="scss"></style>
